const carouselData = {
  services: {
    title: "Other services offered.",
    text: "Our outsourced services expand your capabilities and simplify back-office complexity, so you can focus on the customer experience.",
    buttonText: "Explore Services",
  },
  solutions: {
    title: "One platform, tailored experiences.",
    text: "Whether your business is retail, SME, corporate or payments, Cyberbank can help you kick-start your digital banking transformation or startup project in as little as three months.",
    buttonText: "Contact Sales",
  },
}

export default carouselData
